import {trackAmplitudeEvent} from "@pg-mono/amplitude";
import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {getAmplitudeViewItemEventProperties} from "../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {getCurrencyType} from "../../utils/get_currency";

export const trackHomematchTinderViewItem = (property: IPropertyDetailDTO, index: number) => {
    trackAmplitudeEvent("view_item", {
        ...getAmplitudeViewItemEventProperties({
            offer: {
                ...property.offer,
                id: property.offer.rp_id,
                currency: getCurrencyType(property.region.country),
                region: property.region
            },
            property: {...property, id: property.rp_id, number: property.flat_number, floor: property.floor ?? undefined}
        }),
        location: "homepage",
        index
    });
};

export const trackHomematchTinderRate = (property: IPropertyDetailDTO, value: "like" | "dislike") => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_tinder_rate",
        buttonCategory: "homepage",
        itemId: property.offer.rp_id,
        propertyId: property.rp_id,
        value
    });
};

export const trackHomematchTinderMoreInfo = (property: IPropertyDetailDTO) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_tinder_more_info",
        buttonCategory: "homepage",
        itemId: property.offer.rp_id,
        propertyId: property.rp_id,
        value: "more_info"
    });
};

export const trackHomematchTinderSeeAll = (property: IPropertyDetailDTO) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_tinder_see_all",
        buttonCategory: "homepage",
        itemId: property.offer.rp_id,
        propertyId: property.rp_id,
        buttonLink: property.offer.url,
        value: "see_all"
    });
};

export const trackHomematchTinderClose = (value: "close_x" | "close_outside") => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_tinder_close",
        buttonCategory: "homepage",
        itemId: null,
        value
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";
import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {getAmplitudeViewItemEventProperties} from "../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {getCurrencyType} from "../../utils/get_currency";

export const trackHomematchTinderViewItem = (property: IPropertyDetailDTO, index: number) => {
    trackAmplitudeEvent("view_item", {
        ...getAmplitudeViewItemEventProperties({
            offer: {
                ...property.offer,
                id: property.offer.rp_id,
                currency: getCurrencyType(property.region.country),
                region: property.region
            },
            property: {...property, id: property.rp_id, number: property.flat_number, floor: property.floor ?? undefined}
        }),
        location: "homepage",
        index
    });
};

export const trackHomematchTinderRate = (property: IPropertyDetailDTO, value: "like" | "dislike") => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_tinder_rate",
        buttonCategory: "homepage",
        itemId: property.offer.rp_id,
        propertyId: property.rp_id,
        value
    });
};

export const trackHomematchTinderMoreInfo = (property: IPropertyDetailDTO) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_tinder_more_info",
        buttonCategory: "homepage",
        itemId: property.offer.rp_id,
        propertyId: property.rp_id,
        value: "more_info"
    });
};

export const trackHomematchTinderSeeAll = (property: IPropertyDetailDTO) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_tinder_see_all",
        buttonCategory: "homepage",
        itemId: property.offer.rp_id,
        propertyId: property.rp_id,
        buttonLink: property.offer.url,
        value: "see_all"
    });
};

export const trackHomematchTinderClose = (value: "close_x" | "close_outside") => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_tinder_close",
        buttonCategory: "homepage",
        itemId: null,
        value
    });
};
